import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;
const $D = $(document);
const handlers = {};

$.onModal = (id, init, load) => {
  if (!Utils.isString(id)) {
    [init, load] = [id, init];
    id = undefined;
  }

  if (load === undefined) [init, load] = [undefined, init];
  if (!id) id = $('.modal-dialog').parent().data('modal:id');

  if (id)
    handlers[id] = {
      init,
      load,
    };
};

$.modal = async (href, options) => {
  if (options === undefined) options = {};

  const local = href.startsWith('#');
  const statc = Utils.toBoolean(options.static, false);
  const animation = Utils.toBoolean(options.animation, true);
  const title = options.title;
  const size = options.size;
  const color = options.color;
  const id = options.id || href;
  const config = options.config;
  const selector = `[data-modal\\:id="${CSS.escape(id)}"]`;
  const $existing = $(selector).filter((_, el) => {
    const $el = $(el);
    return $el.data('modal:opening') || $el.hasClass('show');
  });

  if ($existing.length) {
    $existing[0].focus();
    return $existing.data('modal:promise') || Promise.resolve(false);
  }

  const $modal = (
    local
      ? $(href)
      : $(`
          <div>
            <div class="modal-dialog">
              <div class="modal-content"/>
            </div>
          </div>
        `)
  )
    .data('modal:id', id)
    .attr('data-modal:id', id)
    .data('config', config)
    .data('modal:opening', true)
    .removeClass()
    .css('display', 'none')
    .appendTo('body')
    .modal({ show: false, backdrop: false });

  if (!local) {
    const html = await $.get(
      href,
      {},
      {
        headers: {
          'X-USER-TOKEN': W.API.user,
          'X-CSP-NONCE': W.NONCE,
        },
      },
    );

    $modal.find('.modal-content').html(html);
  }

  const modalPromise = new Promise(resolve => {
    $modal
      .data('modal:result', false)
      .removeClass()
      .addClass('modal')
      .off()
      .on('mousedown', '.modal-dialog', evt => {
        if (!statc && $(evt.target).is('.modal-dialog')) $modal.modal('hide');
      })
      .one('show.bs.modal', async function () {
        const handler = handlers[id];

        if (handler && handler.init) await handler.init($modal);
        $modal.initUI();
        if (handler && handler.load) await handler.load($modal, W.AUTH);

        $modal
          .one('shown.bs.modal', function (evt) {
            $modal.removeData('modal:opening');
          })
          .one('hidden.bs.modal', function () {
            const result = $modal.data('modal:result');

            $modal.removeData('modal:promise').removeData('modal:opening');

            if (!local) $modal.remove();
            resolve(result);
          });
      });

    if (['full'].includes(size)) $modal.addClass('modal-full');
    if (['sm', 'small'].includes(size)) $modal.addClass('modal-sm');
    if (['md', 'medium'].includes(size)) $modal.addClass('modal-md');
    if (['lg', 'large'].includes(size)) $modal.addClass('modal-lg');
    if (['xl'].includes(size)) $modal.addClass('modal-xl');
    if (animation) $modal.addClass('fade');
    if (statc) $modal.addClass('modal-static');
    if (color) $modal.addClass(`modal-${color}`);
    if (title) $modal.find('.modal-header :header').html(title);

    $modal.modal('show');
  });

  $modal.data('modal:promise', modalPromise);

  return modalPromise;
};

$.confirm = async (msg, title, options) => {
  if (typeof title === 'object') [title, options] = [undefined, title];
  if (options === undefined) options = {};

  const statc = Utils.toBoolean(options.static, false);
  const animation = Utils.toBoolean(options.animation, true);
  const size = options.size;
  const color = options.color;

  const $modal = $(`
    <div>
      <div class="modal-dialog modal-confirm">
        <div class="modal-content">
          <div class="modal-header"><h2></h2></div>
          <div class="modal-body"></div>
          <div class="modal-footer">
            <button class="btn btn-no btn-secondary btn-fixed mr-2" data-dismiss="modal"></button>
            <button class="btn btn-yes btn-primary btn-fixed" data-dismiss="modal"></button>
          </div>
        </div>
      </div>
    </div>
  `)
    .css('display', 'none')
    .appendTo('body')
    .modal({ show: false, backdrop: false });

  return new Promise(resolve => {
    $modal
      .data('modal:result', false)
      .addClass('modal')
      .on('click', '.btn', evt => {
        $modal.data('modal:result', $(evt.target).is('.btn-yes'));
      })
      .on('mousedown', '.modal-dialog', evt => {
        if (!statc && $(evt.target).is('.modal-dialog')) $modal.modal('hide');
      })
      .one('hidden.bs.modal', function () {
        const result = $modal.data('modal:result');
        $modal.remove();
        resolve(result);
      });

    if (['sm', 'small'].includes(size)) $modal.addClass('modal-sm');
    if (['lg', 'large'].includes(size)) $modal.addClass('modal-lg');
    if (animation) $modal.addClass('fade');
    if (statc) $modal.addClass('modal-static');
    if (color) $modal.addClass(`modal-${color}`);
    $modal.find('.modal-header :header').html(title || options.title || 'Confirm');
    $modal.find('.modal-body').html(msg);
    $modal.find('.btn-yes').text(options.yesText || 'Yes');
    $modal.find('.btn-no').text(options.noText || 'No');

    $modal.modal('show');
  });
};

$D.on('click', '[data-modal]', async evt => {
  const $obj = $(evt.target).closest('a');
  const data = $obj.data();
  const href = data.href || $obj.attr('href');

  evt.preventDefault();

  const result = await $.modal(href, data);
  $obj.trigger('modal:result', result);
});
